import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class StatsService {
  private statsSource = new BehaviorSubject<any>(null);
  stats$ = this.statsSource.asObservable();

  constructor() { }

  updateStats(data: any) {
    this.statsSource.next(data);
  }
}
